import React, { useState } from "react";
import { useAuth } from "@/hooks/AuthContext";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { Calendar as CalendarIcon, LogIn, LogOut, Menu } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { NotificationMenu } from "@/components/NotificationMenu";
import { UserNotificationMenu } from "@/components/UserNotificationMenu";
export function Nav() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isSheetOpen, setIsSheetOpen] = useState(false);

  const navLinkClasses = ({ isActive }) => {
    const base = "px-3 py-2 rounded-md text-sm font-medium transition-colors";
    return `${base} ${isActive ? "bg-muted" : "hover:bg-muted/50"}`;
  };

  const mobileNavLinkClasses = ({ isActive }) => {
    const base =
      "block px-3 py-2 rounded-md text-base font-medium transition-colors";
    return `${base} ${isActive ? "bg-muted" : "hover:bg-muted/50"}`;
  };

  return (
    <div className="nav lg:-mx-6">
      {/* Mobile - Hamburger Menu */}
      <Sheet open={isSheetOpen} onOpenChange={setIsSheetOpen}>
        <SheetTrigger asChild className="lg:hidden">
          <Button variant="ghost" size="icon">
            <Menu size={24} />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="w-64 p-4">
          <div className="flex flex-col gap-2">
            <NavLink
              to="/"
              className={mobileNavLinkClasses}
              onClick={() => setIsSheetOpen(false)}
            >
              My Day
            </NavLink>
            <NavLink
              to="/calendar"
              className={mobileNavLinkClasses}
              onClick={() => setIsSheetOpen(false)}
            >
              Calendar
            </NavLink>
            <NavLink
              to="/projects"
              className={mobileNavLinkClasses}
              onClick={() => setIsSheetOpen(false)}
            >
              Projects
            </NavLink>
            <NavLink
              to="/tasks"
              className={mobileNavLinkClasses}
              onClick={() => setIsSheetOpen(false)}
            >
              Task Manager
            </NavLink>
            {user?.role === "ADMIN" && (
              <NavLink
                to="/admin/hr"
                className={mobileNavLinkClasses}
                onClick={() => setIsSheetOpen(false)}
              >
                Admin HR
              </NavLink>
            )}
            {user?.role === "ADMIN" && (
              <NavLink
                to="/reports"
                className={mobileNavLinkClasses}
                onClick={() => setIsSheetOpen(false)}
              >
                Reports
              </NavLink>
            )}
          </div>
        </SheetContent>
      </Sheet>

      {/* Logo */}
      <div className="nav-left">
        <div className="absolute left-1/2 transform -translate-x-2/3 lg:static lg:transform-none">
          <div className="flex items-center gap-2">
            <CalendarIcon size={20} />
            <span className="brand">METABOLIC OFFICE</span>
          </div>
        </div>
      </div>

      {/* Desktop Nav Links */}
      <div className="hidden lg:flex nav-links">
        <NavLink to="/" className={navLinkClasses}>
          My Day
        </NavLink>
        <NavLink to="/calendar" className={navLinkClasses}>
          Calendar
        </NavLink>
        <NavLink to="/projects" className={navLinkClasses}>
          Projects
        </NavLink>
        <NavLink to="/tasks" className={navLinkClasses}>
          Task Manager
        </NavLink>
        {/* <NavLink to="/team" className={navLinkClasses}>Team</NavLink> */}
        {user?.role === "ADMIN" && (
          <NavLink to="/admin/hr" className={navLinkClasses}>
            Admin HR
          </NavLink>
        )}
        {user?.role === "ADMIN" && (
          <NavLink to="/settings" className={navLinkClasses}>
            Settings
          </NavLink>
        )}
        {user?.role === "ADMIN" && (
          <NavLink to="/reports" className={navLinkClasses}>
            Reports
          </NavLink>
        )}
      </div>

      {/* Right side */}
      {/* Right side */}
      <div className="nav-right">
        {user ? (
          <div className="flex items-center gap-2">
            {/* <NotificationMenu />  */}
            <UserNotificationMenu /> {/* 👈 New Bell */}
            {(user?.role === "ADMIN" || user?.role === "PM") && (
              <span className="text-black text-sm font-medium hidden sm:block">
                {user.name} • {user.role}
              </span>
            )}
            {(user?.role === "TEAM") && (
              <span className="text-black text-sm font-medium hidden sm:block">
                {user.name}
              </span>
            )}
            <Button
              size="sm"
              onClick={() => {
                logout();
                navigate("/login");
              }}
            >
              <LogOut size={14} className="mr-1" />
              Logout
            </Button>
          </div>
        ) : (
          <Button size="sm" onClick={() => navigate("/login")}>
            <LogIn size={14} className="mr-1" />
            Login
          </Button>
        )}
      </div>
    </div>
  );
}
